import { Alert } from "@dealer-center/core-components";
import type { permissionsManagerAPIInterface } from "@dealer-center/ddc-pages-permissions-manager-interface";
import styled from "styled-components";

const StyledResultsArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StyledAlert = styled(Alert)`
  margin-bottom: 1rem;
`;

const StyledResultArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StyledResultHeader = styled.h2`
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
`;

const StyledResultPre = styled.pre`
  font-size: 1rem;
  font-weight: 400;
  margin-bottom: 1rem;
  max-height: 400px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
`;

interface PagesPermissionsManagerUiResultsProps {
  data?: permissionsManagerAPIInterface;
  error?: string;
}

export const PagesPermissionsManagerUiResults = ({
  data,
  error
}: PagesPermissionsManagerUiResultsProps) => {
  if (error) {
    return (
      <StyledResultsArea>
        <StyledAlert role="alert" sx={{ marginBottom: "16px" }} type="error">
          {error}
        </StyledAlert>
      </StyledResultsArea>
    );
  }

  if (!data) {
    return (
      <StyledResultsArea>
        <StyledAlert role="alert" sx={{ marginBottom: "16px" }} type="info">
          No data
        </StyledAlert>
      </StyledResultsArea>
    );
  }

  return (
    <StyledResultsArea>
      <StyledResultArea>
        <StyledResultHeader>Permissions</StyledResultHeader>
        {/* <StyledResultPre>{JSON.stringify("TEST DATA")}</StyledResultPre> */}
        <StyledResultPre>{JSON.stringify(data, null, 2)}</StyledResultPre>
      </StyledResultArea>
    </StyledResultsArea>
  );
};
